import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";

const ProfitLossReport = () => {
  const { user } = useAuth();
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
  const [toDate, setToDate] = useState(moment().format('YYYY-MM-DD'));

  const fetchReport = async () => {
    setLoading(true);
    try {
      const url = `${config.GET_PL_REPORT}/${user.cid}?fromDate=${fromDate}&toDate=${toDate}`;
      const res = await apiService.getAll(url);
      setReport(res);
    } catch (error) {
      console.error("Error fetching P&L:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { if (user) fetchReport(); }, [user]);

  const formatCurr = (n) => "₹ " + (n || 0).toLocaleString(undefined, { minimumFractionDigits: 2 });

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            
            <h4 className="mb-4">Profit & Loss Statement</h4>

            {/* Date Filters */}
            <div className="card mb-4">
              <div className="card-body d-flex align-items-end gap-3">
                <div>
                  <label className="form-label">From Date</label>
                  <input type="date" className="form-control" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                </div>
                <div>
                  <label className="form-label">To Date</label>
                  <input type="date" className="form-control" value={toDate} onChange={(e) => setToDate(e.target.value)} />
                </div>
                <button className="btn btn-primary" onClick={fetchReport}>Generate Report</button>
              </div>
            </div>

            {loading ? <p>Calculating...</p> : report && (
              <div className="row justify-content-center">
                <div className="col-md-8">
                  <div className="card shadow border-0">
                    <div className="card-body p-5">
                      <h5 className="text-center text-uppercase fw-bold mb-4">Statement of Profit and Loss</h5>
                      <p className="text-center text-muted">Period: {moment(fromDate).format('DD MMM YYYY')} to {moment(toDate).format('DD MMM YYYY')}</p>
                      
                      <hr />

                      {/* INCOME SECTION */}
                      <div className="mt-4">
                        <h6 className="fw-bold text-success border-bottom pb-2">REVENUE (A)</h6>
                        {report.revenueBreakdown.map((item, i) => (
                          <div className="d-flex justify-content-between my-2" key={i}>
                            <span>{item.accountName}</span>
                            <span className="fw-medium">{formatCurr(item.amount)}</span>
                          </div>
                        ))}
                        <div className="d-flex justify-content-between mt-3 fw-bold bg-light p-2">
                          <span>Total Revenue</span>
                          <span>{formatCurr(report.totalRevenue)}</span>
                        </div>
                      </div>

                      {/* EXPENSE SECTION */}
                      <div className="mt-5">
                        <h6 className="fw-bold text-danger border-bottom pb-2">OPERATING EXPENSES (B)</h6>
                        {report.expenseBreakdown.map((item, i) => (
                          <div className="d-flex justify-content-between my-2" key={i}>
                            <span>{item.accountName}</span>
                            <span className="fw-medium">({formatCurr(item.amount)})</span>
                          </div>
                        ))}
                        <div className="d-flex justify-content-between mt-3 fw-bold bg-light p-2 text-danger">
                          <span>Total Expenses</span>
                          <span>({formatCurr(report.totalExpenses)})</span>
                        </div>
                      </div>

                      {/* NET PROFIT */}
                      <div className="mt-5 p-3 rounded border border-2 border-primary bg-soft-primary">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="mb-0 fw-bold text-primary">NET PROFIT (A - B)</h5>
                          <h4 className={`mb-0 fw-bold ${report.netProfit >= 0 ? 'text-success' : 'text-danger'}`}>
                            {formatCurr(report.netProfit)}
                          </h4>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfitLossReport;